import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Calendar, Check } from "lucide-react";
import { toast } from "sonner";

const OPTIONS = [
  { key: "off", label: "Off",    sub: "No automated weekly digest." },
  { key: "sun", label: "Sunday", sub: "Send the Week-Ahead digest Sundays at 6 PM ET." },
  { key: "mon", label: "Monday", sub: "Send the Week-Ahead digest Mondays at 8 AM ET." },
];

export default function DigestScheduleCard() {
  const [schedule, setSchedule] = useState(null);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    api.get("/teams/me/digest-schedule").then(({ data }) => setSchedule(data.schedule)).catch(() => setSchedule("sun"));
  }, []);

  const save = async (next) => {
    setSaving(next);
    try {
      await api.put("/teams/me/digest-schedule", { schedule: next });
      setSchedule(next);
      toast.success(`Digest schedule set to ${next === "off" ? "off" : next === "sun" ? "Sunday 6 PM ET" : "Monday 8 AM ET"}`);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(null); }
  };

  return (
    <section className="rounded-xl ink-card p-6" data-testid="digest-schedule-card">
      <div className="flex items-center gap-3">
        <Calendar className="h-5 w-5" style={{ color: "var(--brand-secondary)" }} />
        <div>
          <h2 className="font-display font-bold text-lg text-white">Week-Ahead Digest</h2>
          <p className="text-sm text-white/50 mt-0.5">When should ArmIQ send the 7-day forecast to your athletes &amp; their parents?</p>
        </div>
      </div>

      <div className="mt-5 grid sm:grid-cols-3 gap-3">
        {OPTIONS.map((o) => {
          const active = schedule === o.key;
          return (
            <Button
              key={o.key}
              type="button"
              onClick={() => save(o.key)}
              disabled={saving !== null}
              className={`h-auto p-4 rounded-xl text-left flex flex-col items-start gap-2 transition ${active ? "ring-2" : "ring-1 hover:bg-white/[0.04]"}`}
              style={{
                backgroundColor: active ? "rgba(217,4,41,0.10)" : "var(--ink-1)",
                ringColor: active ? "var(--brand-secondary)" : "var(--ink-border)",
                color: "white",
              }}
              data-testid={`digest-option-${o.key}`}
            >
              <div className="flex items-center gap-2 w-full">
                <span className="font-display font-bold text-base">{o.label}</span>
                {active && <Check className="h-4 w-4 ml-auto" style={{ color: "var(--brand-secondary)" }} />}
              </div>
              <span className="text-[11px] text-white/55 leading-snug">{o.sub}</span>
            </Button>
          );
        })}
      </div>
    </section>
  );
}
